define((require) => {
    "use strict";

    var Marionette              = require("marionette"),
        _                       = require("underscore"),
        Promise                 = require("shared/util/Promise"),
        DashboardConfiguration  = require("ui/dashboard/DashboardConfiguration"),
        DashboardView           = require("ui/dashboard/DashboardView");


    /**
     * Controller for the dashboard.
     *
     * For projects, see ProjectDashboardController.
     *
     * @class LazyDashboardController
     */
    return Marionette.Controller.extend({

        config: DashboardConfiguration,

        dashboardView: DashboardView,

        /**
         * Hook for providing additional options to the dashboard view instance.<p>
         *
         * Note that this method is only invoked once. The default implementation resolves
         * with the same specified options.
         *
         * @param  {*} options The initial options passed to #show
         * @return {Promise}   A <tt>Promise</tt> that resolves with the options to be passed
         * to the dashboard view instance.
         */
        dashboardViewOptions: function(options) {
            return Promise.resolved(options);
        },

        /**
         * @type {DashboardView}
         */
        _view: null,

        /**
         * Shows the dashboard at the tab specified or the "Experiences" tab if none is provided.
         *
         * @param  {*} options The options:
         *                     @cfg tab Optional, the tab to show, as a Tabs.XXX constant.
         */
        show: function(options) {
            var tab = options.tab || this.config.EXPERIENCES,
                region = this.options.region;

            if (options.reset) {
                this._disposeDashboardView();
            }

            // First run...
            if (!this._view) {
                var viewOptions = _.defaults({tabs: this.config}, options);
                // Fetch any additional (initial) dashboard view options.
                this.dashboardViewOptions(viewOptions)
                    .then((viewOptions) => {
                        this.onBeforeDashboardShow(viewOptions);
                        this._view = new this.dashboardView(viewOptions);
                        region.show(this._view);
                        this._view.showTab(tab);
                    });
            } else {
                // Pass on potential partial view options... (e.g. quick view parameters)
                this._view.options.partialViewOptions = options.partialViewOptions;
                this._view.showTab(tab);
            }
        },

        /**
         * Invoked after the <tt>dashboardViewOptions</tt> successfully
         * resolves, before the dashboard view is constructed and shown.
         *
         * @param  {*} options The options to be passed to the dashboard view.
         */
        // eslint-disable-next-line no-unused-vars
        onBeforeDashboardShow: function(options) {
        },

        _disposeDashboardView: function() {
            if (this._view) {
                this._view.stopListening();
                this._view = null;
            }
        },

        onClose: function() {
            this._disposeDashboardView();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/DashboardController.js